import {
    CButton,
    CModal,
    CModalBody,
} from "@coreui/react";
import * as Yup from "yup";

import { useFormik } from "formik";
import { useEffect, useState } from "react";
import crossButton from "../assets/image/crossButton.svg";
import '../common/styles/changePassword.css'
import '../common/styles/createAdmin.css'
import { ColorTheme } from "../../constant/ColorTheme";
import personal_png from "../assets/image/personal-profile.svg"
import { connect, useDispatch, useSelector } from "react-redux";
import { hideEditProfileModal, showEditProfileModal } from "../../redux/actionDispatcher/auth/editProfileModalDispatch";
import { editProfileRequest } from "../../redux/actionDispatcher/auth/editProfileDispatcher";
import LoaderButton from "../common/LoaderButton";
import { ApiURLs, imageBaseUrls } from "../../constant/ApiUrls";

function EditProfile({editProfile,editProfileRequest}) {
    const dispatch = useDispatch();
    const isModalVisible = useSelector((state) => state.editProfileModalReducer.isModalVisible);
       const userData = useSelector((state) => state.auth.userInfo);
   
    const [image, setImage] = useState(null);
    const [uploadImage, setuploadImage] = useState(null);
    console.log(userData.name);
    const validationSchema = Yup.object({
        name: Yup.string()

            .required("Please Enter Password"),
    });
    const formik = useFormik({
        initialValues: {
            name: userData?.name ||"Hadh",
            // profile_image: userData?.profile_image ||"Hadh"
        }, enableReinitialize: true,
        validationSchema,


        onSubmit:async (values) => {
            // // console.log(values);
            var data = {

                name: formik.values.name,
            };
            if(image){
                data.profile_image = uploadImage;
            }
            console.log(data);
            editProfileRequest(data)
        },
    });
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          const imageUrl = URL.createObjectURL(file);
          setImage(imageUrl);
          setuploadImage(file)
        }
      };
      useEffect(() => {
        console.log("Modal Visibility Changed:", isModalVisible);
    }, [isModalVisible]);
    useEffect(() => {

        // console.log(formik.errors);
    }, [formik.errors])
    return (<div>
        <CButton
            className="personal-setting-button button"
            onClick={() => dispatch(showEditProfileModal())}
        >Edit Profile
        </CButton>
        <CModal
            alignment="center"
            visible={isModalVisible}
            onClose={() => {
                console.log("user ---- data",userData.image);
                console.log("user ---- data",formik);
                formik.handleReset();
                dispatch(hideEditProfileModal());
            }}
        >
            <CModalBody className="my-modal-body" >
                <div className="main-container createAdmin ">
                    <div className=" cross-btn-div d-flex ">
                        <img onClick={() => dispatch(hideEditProfileModal())}
                            src={crossButton} alt="close" className="cross-button" />
                    </div>
                    <form onSubmit={formik.handleSubmit} className="login-form">

                        <div className="mb-4">
                            <h4 className="h4 fw-bold" style={{ color: ColorTheme.colors.primary }}> <b>Edit Profile</b></h4>
                        </div>
                        <div className="mb-3 input-login-box">
                            <div className="form-row d-flex justify-content-center  mt-2  " >
                                {/* Hidden File Input */}
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    id="imageUpload"
                                    onChange={handleImageChange}
                                />
                                <img  onClick={() => document.getElementById("imageUpload").click()} src={image || imageBaseUrls+userData.image} alt="logo ssism" className="personal-profile" />{" "}
                            
                            </div>

                            <input

                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="name"
                                type="name"
                                className="form-control login-input mt-3"
                                placeholder="Full Name"
                            disabled={editProfile.loading}
                            />
                            {formik.errors.name && formik.touched.name ? (
                                <div className="text-danger fs-6">{formik.errors.name}</div>
                            ) : (
                                ""
                            )}

                        </div>


                        <button
                            className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                            type="submit"
                            onClick={console.log('clciked ')}
                        disabled={editProfile.loading}
                        >
                            {/* used loader for button here ============= */}
                            {
                                editProfile.loading ? (<LoaderButton />) :

                                "Submit"}
                        </button>

                    </form>
                </div>
            </CModalBody>
        </CModal>

    </div>);
}
const mapStateToProps = (state) => {
    return {
        editProfile: state.editProfile,
    };
};

//passing the changePassword in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
    return {
        editProfileRequest: (data, navigate) => dispatch(editProfileRequest(data, navigate)),
    };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(EditProfile);
